import React from 'react'
import { Grid, Button, useTheme, useMediaQuery } from '@material-ui/core'
import { Link } from 'react-router-dom'
import MaterialTable from 'material-table'

import { tableIcons } from '../Devs/icons'
import { onboarder } from '../../../api'
import Spinner from '../../Spinner/Spinner'
import useDynamicMaxBodyHeight from '../../../hooks/useDynamicMaxBodyHeight'
import CustomTableCell from '../../CustomTableCell/CustomTableCell'

export default function ScriptsList () {
  document.title = 'Scripts | Superstruct Platform'

  const [scripts, setScripts] = React.useState([])
  const [thrownError, setThrownError] = React.useState(null)
  const [loaded, setLoaded] = React.useState(false)
  const maxBodyHeight = useDynamicMaxBodyHeight(230)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

  const fn = (error, response) => {
    if (response) {
      setLoaded(true)
      setScripts(response)
    } else {
      setLoaded(true)
      setThrownError(error)
    }
  }

  React.useEffect(() => {
    onboarder.listScripts(fn)
  }, []); //eslint-disable-line

  if (thrownError) {
    return (
      <>
        <Grid>
          <Grid>{`ERROR: ${thrownError}`}</Grid>
        </Grid>
      </>
    )
  }

  if (!loaded) {
    return <Spinner />
  }

  return (
    <>
      <Grid container>
        <Grid item style={{ width: '100%' }}>
          <Button
            variant='contained'
            color='primary'
            style={{ marginBottom: '10px' }}
            component={Link}
            to='/onboarder/scripts/create'
          >
            Add Scripts
          </Button>
          <MaterialTable
            style={{ fontSize: isMobile ? '90%' : '75%' }}
            icons={tableIcons}
            title='Scripts'
            columns={[
              { title: 'Name', field: 'name' },
              { title: 'Articles', field: 'articles.length', emptyValue: '0' }
            ]}
            data={scripts}
            options={{
              search: true,
              paging: false,
              filtering: true,
              maxBodyHeight
            }}
            actions={[
              (rowData) => ({
                icon: () => (
                  <Link
                    to={`/onboarder/scripts/${rowData.id}`}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    <tableIcons.Edit />
                  </Link>
                ),
                tooltip: 'Edit'
              })
            ]}
            components={{
              Cell: (props) =>
                <CustomTableCell props={props} isMobile={isMobile} />
            }}
          />
        </Grid>
      </Grid>
    </>
  )
}
